var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m_posts"},[_c('strong',{attrs:{"desc":"로그인 리스트"}},[_vm._v(_vm._s(_vm.portlet.title))]),_c('ul',_vm._l((this.lists),function(value,name){return _c('li',{key:name},[_c('a',[(value.category)?_c('em',[_vm._v("["+_vm._s(value.category)+"]")]):_vm._e(),_vm._v(_vm._s(value.subject))])])}),0),_c('span',{staticClass:"m_more"},[_c('router-link',{attrs:{"to":{
        name: `loglist`,
        query: {
          data: JSON.stringify({
            lnbid: _vm.portlet.lnbid,
            type: _vm.portlet.type,
            top: _vm.portlet.lnbid,
            title: _vm.portlet.title,
          }),
        },
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }